import React, { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { Box, CircularProgress, Typography } from '@mui/material';
import {
  getK9DesktopDashboardUrl,
  shouldShowK9QuickMenu,
} from '../../utils/k9QuickMenuDevice';
import { APEX_K9_MARK } from '../../../shared/branding/apexK9';

/**
 * k9.* root and unknown paths: field devices → Quick Menu; desktop → apex dashboard.
 */
const K9SubdomainEntryRedirect: React.FC = () => {
  const showQuickMenu = shouldShowK9QuickMenu();

  useEffect(() => {
    if (!showQuickMenu) {
      window.location.replace(getK9DesktopDashboardUrl());
    }
  }, [showQuickMenu]);

  if (showQuickMenu) {
    return <Navigate to="/k9-ops/quick-menu" replace />;
  }

  return (
    <Box
      sx={{
        flex: 1,
        width: '100%',
        minWidth: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: 'background.default',
        flexDirection: 'column',
        gap: 2,
        p: 3,
      }}
    >
      <CircularProgress />
      <Typography variant="body2" color="text.secondary">
        {`Opening ${APEX_K9_MARK} dashboard…`}
      </Typography>
    </Box>
  );
};

export default K9SubdomainEntryRedirect;
